import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 7H14.67L13.29 8.37L14.71 9.79L18.49 6L14.71 2.22L13.29 3.63L14.66 5H4V13H6V7Z" fill={ fill || 'currentColor' } />
        <path d="M20 11H18V17H9.34L10.71 15.63L9.29 14.21L5.51 18L9.29 21.79L10.71 20.37L9.34 19H20V11Z" fill={ fill || 'currentColor' } />
    </svg>

);
